import { Card } from '@shared/ui';
import * as st from './styles.module.scss';

export const ExerciseCardSkeleton = () => (
  <Card className={st.card}>
    <div className={st.image} />
    <div className={st.titles}>
      <div className={st.title} />
      <div className={st.title} />
    </div>
  </Card>
);
